import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SearchBar from "components/SearchBar";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Input, Label, Row, Spinner, Table } from "reactstrap";
import { weekAgo, today, formatNumber } from "redux/action/api";
import { postApi } from "redux/action/api_tbeams";

export default function MemoReleaseTab() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [memos, setMemos] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [form, setForm] = useState({
    date_from: weekAgo,
    date_to: today,
  });

  const handleChanges = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const getApprovedMemos = useCallback(() => {
    setIsLoading(true);
    postApi("memo/approved", {
      date_from: form.date_from,
      date_to: form.date_to,
    })
      .then((data) => {
        if (data.result) {
          setMemos(data.result);
        }
      })
      .catch(console.log)
      .finally(() => setIsLoading(false));
  }, [form.date_from, form.date_to]);

  useEffect(() => {
    getApprovedMemos();
  }, [getApprovedMemos]);

  const filteredData = memos.filter(
    (item) =>
      item.mda_name?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
      item.economic_code?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const styles = { fontSize: 14, verticalAlign: "middle" };
  const bodyStyle = { fontSize: 13, padding: "8px" };

  return (
    <>
      <Row style={{ margin: 10 }}>
        <Col md={6}>
          <Label>Search</Label>
          <SearchBar
            placeholder="Search by MDA or Economic Code"
            filterText={searchQuery}
            onFilterTextChange={(e) => setSearchQuery(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Label>Date From</Label>
          <Input type="date" value={form.date_from} name="date_from" onChange={handleChanges} />
        </Col>
        <Col md={3}>
          <Label>Date To</Label>
          <Input type="date" value={form.date_to} name="date_to" onChange={handleChanges} />
        </Col>
      </Row>

      <div className="mt-4" style={{ width: "100%", height: 400, overflowX: "auto" }}>
        <Table bordered hover style={{ width: "100%" }}>
          <thead style={{ backgroundColor: "#f8f9fa" }}>
            <tr>
              <th style={styles}>Action</th>
              <th style={styles}>Memo Date</th>
              <th style={styles}>MDA</th>
              <th style={styles}>Economic Code</th>
              <th style={styles}>Program Code</th>
              <th style={styles}>Description</th>
              <th style={styles}>Amount</th>
              <th style={styles}>Status</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan={8} className="text-center" style={{ padding: "20px" }}>
                  <Spinner color="primary" />
                  <div className="mt-2">Loading memos...</div>
                </td>
              </tr>
            </tbody>
          ) : filteredData.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={8} className="text-center" style={{ padding: "20px", color: "#666" }}>
                  No memos found
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {filteredData.map((item, idx) => (
                <tr key={idx}>
                  <td style={bodyStyle}>
                    <Button
                      color="info"
                      size="sm"
                      onClick={() => navigate(`/view-memo?id=${item.id}&memoType=Director&status=${item.status}&display=false`)}
                    >
                      View
                    </Button>
                  </td>
                  <td style={bodyStyle}>{item.memo_date}</td>
                  <td style={bodyStyle}>{item.mda_name}</td>
                  <td style={bodyStyle}>{item.economic_code}</td>
                  <td style={bodyStyle}>{item.program_code || "-"}</td>
                  <td style={bodyStyle}>{item.description}</td>
                  <td style={{ ...bodyStyle, textAlign: "right", fontWeight: "500" }}>
                    {formatNumber(item.amount)}
                  </td>
                  <td style={bodyStyle}>
                    <span
                      style={{
                        padding: "4px 8px",
                        borderRadius: "4px",
                        backgroundColor: item.status === "Approved" ? "#d4edda" : "#fff3cd",
                        color: item.status === "Approved" ? "#155724" : "#856404",
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                    >
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>
      </div>
    </>
  );
}
